<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm) ">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-card-plus"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingCard"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="card.code"
                        >
                          <v-text-field
                            v-model="card.code"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.code')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="card.name"
                        >
                          <v-text-field
                            v-model="card.name"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.name')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules=""
                          name="card.priceCost"
                        >
                          <v-text-field
                            v-model.number="card.priceCost"
                            outlined
                            name="card.priceSell"
                            :label="$t('fields.card.priceCost')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="card.priceSell"
                        >
                          <v-text-field
                            v-model.number="card.priceSell"
                            outlined
                            name="card.priceSell"
                            :label="$t('fields.card.priceSell')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="max:50"
                          name="card.cardType"
                        >
                          <v-text-field
                            v-model="card.cardType"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.cardType')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="max:50"
                          name="card.artType"
                        >
                          <v-text-field
                            v-model="card.artType"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.artType')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="max:50"
                          name="card.printType"
                        >
                          <v-text-field
                            v-model="card.printType"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.printType')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="max:50"
                          name="card.edition"
                        >
                          <v-text-field
                            v-model="card.edition"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.edition')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="max:50"
                          name="card.language"
                        >
                          <v-text-field
                            v-model="card.language"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.language')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="card.state"
                        >
                          <v-switch
                            v-model="card.state"
                            class="mx-2"
                            :label="$t('fields.card.state')"
                            :error-messages="errors"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|numeric"
                          name="card.inventory"
                        >
                          <v-text-field
                            v-model.number="card.inventory"
                            outlined
                            name="card.inventory"
                            :label="$t('fields.card.inventory')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules=""
                          name="card.gameLineId"
                        >
                          <v-select
                            v-model="card.gameLineId"
                            :items="gameLines"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.card.gameLineId')"
                            :error-messages="errors"
                            outlined
                            @change="changeGame()"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules=""
                          name="card.gameExpansionId"
                        >
                          <v-select
                            v-model="card.gameExpansionId"
                            :items="gameExpansions"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.card.gameExpansionId')"
                            :error-messages="errors"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules=""
                          name="card.categoryId"
                        >
                          <v-select
                            v-model="card.rarityId"
                            :items="gameRarities"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.card.rarityId')"
                            :error-messages="errors"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <!-- sections -->
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          name="card.sections"
                        >
                          <v-select
                            v-model="card.sectionsId"
                            :items="sections"
                            item-text="title"
                            item-value="id"
                            :label="$t('fields.card.sections')"
                            :error-messages="errors"
                            multiple
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      class="mx-auto"
                      justify="space-around"
                      style="max-width: 500px;"
                    >
                      <v-col
                        cols="auto"
                        class="text-center"
                      >
                        <input
                          ref="file"
                          type="file"
                          class="d-none"
                          @change="selectImage"
                        >
                        <div class="font-weight-bold grey--text">
                          Selecciona una imagen
                        </div>
                        <v-card
                          :class="imagePreview ? 'success--text' : 'grey--text'"
                          class="mx-auto mt-0 d-inline-flex v-card--account"
                          outlined
                          height="400"
                          width="300"
                          @click="$refs.file.click()"
                        >
                          <v-img
                            v-if="imagePreview"
                            :src="imagePreview"
                            height="100%"
                            width="100%"
                          />
                          <v-icon
                            v-else
                            class="mx-auto"
                            size="96"
                          >
                            mdi-account
                          </v-icon>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                    :loading="loadingSave"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <v-snackbar
      v-model="showErrorMessage"
      top
      :multi-line="true"
      color="error"
    >
      {{ errorMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showErrorMessage = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="showSuccessMessage"
      top
      :multi-line="true"
      color="success"
    >
      {{ successMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showSuccessMessage = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const cardsRespository = repositoryFactory.get('cards')
  const gameRaritiesRepository = repositoryFactory.get('gameRarities')
  const gameLinesRepository = repositoryFactory.get('gameLines')
  const gameExpansionsRepository = repositoryFactory.get('gameExpansions')
  const sectionsRepository = repositoryFactory.get('sections')

  export default {
    inject: ['theme'], // ??
    name: 'CardCrud',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      card: {
        state: true,
        gameLineId: null,
        gameExpansionId: null,
        rarityId: null,
      },
      imagePreview: null,
      imageBytes: null,
      sections: [],
      gameRarities: [{ name: 'Seleccione Rareza', id: null }],
      gameLines: [{ name: 'Seleccione Juego', id: null, gameExpansion: [] }],
      gameExpansions: [{ name: 'Seleccione Expansión', id: null }],
      showErrorMessage: false,
      showSuccessMessage: false,
      errorMessage: '',
      successMessage: '',
      loadingCard: false,
      formAction: null,
      loadingSave: false,
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-card') : this.$t('modify-card')
      },
    },
    async mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingCard = true
        var id = this.$route.params.id
        await cardsRespository.getById(id).then(response => {
          self.loadingCard = false
          self.card = Object.assign({}, response.data.data)
          console.log(self.card)
          if (self.card.sections != null) {
            self.card.sectionsId = self.card.sections.map((x) => x.id)
          }
          if (self.card.cardImage.length > 0) {
            self.imagePreview = self.card.cardImage[0].url
          }
        }).catch(err => {
          self.loadingCard = false
          self.errorMessage('Error cargando carta ', err)
          self.showErrorMessage = true
        })
        await this.getGames()
        await this.getSections()
        await this.getExpansions(self.card.gameLineId)
        await this.getRarities(self.card.gameLineId)
      } else {
        await this.getGames()
        await this.getSections()
      }
    },
    methods: {
      submitForm (scope) {
        var self = this
        if (this.card.sectionsId != null) {
          this.card.sections = this.card.sectionsId.map((x) => {
            return {
              id: x,
              title: '',
            }
          })
        }
        var data = new FormData()
        data.append('data', JSON.stringify(this.card))
        if (this.imageBytes != null) {
          data.append('imageBytes', this.imageBytes, this.imageBytes.name)
        } else {
          data.append('imageBytes', null)
        }

        // var data = {
        //   data: this.card,
        // }
        self.loadingSave = true
        if (self.formAction !== 'add') {
          data.append('id', this.card.id)
          cardsRespository.updateCard(data, this.card.id).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage('Error guardando información: ', err)
            self.showErrorMessage = true
            self.loadingSave = true
          })
        } else {
          console.log(data)
          cardsRespository.addCard(data).then(response => {
            if (response.data.isValid) {
              self.goToList()
              self.formAction = 'modify'
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage('Error guardando información: ', err)
            self.showErrorMessage = true
            self.loadingSave = false
          })
        }
      },
      selectImage (val) {
        var self = this
        const value = val.target.files[0]
        if (!value) return (self.imagePreview = null)
        self.imagePreview = URL.createObjectURL(value)
        self.imageBytes = value
      },
      async getGames () {
        var self = this
        await gameLinesRepository.get().then(response => {
          response.data.data.map(function (item) {
            self.gameLines.push(item)
          })
        }).catch(err => {
          self.errorMessage('Error obteniendo juegos: ', err)
          self.showErrorMessage = true
        })
      },
      async getRarities (gameId) {
        var self = this
        await gameRaritiesRepository.getByGame(gameId).then(response => {
          response.data.data.map(function (item) {
            self.gameRarities.push(item)
          })
        }).catch(err => {
          self.errorMessage('Error obteniendo rarezas: ', err)
          self.showErrorMessage = true
        })
      },
      async getExpansions (gameId) {
        var self = this
        await gameExpansionsRepository.getByGame(gameId).then(response => {
          response.data.data.map(function (item) {
            self.gameExpansions.push(item)
          })
        }).catch(err => {
          self.errorMessage('Error obteniendo expansiones: ', err)
          self.showErrorMessage = true
        })
      },
      getSections () {
        var self = this
        sectionsRepository.get().then(response => {
          self.sections = response.data.data
        }).catch(err => {
          self.errorMessage('Error obteniendo secciones: ', err)
          self.showErrorMessage = true
        })
      },
      goToList () {
        this.$router.push({ name: 'cards' })
      },
      async changeGame () {
        var self = this
        self.card.gameExpansionId = null
        self.card.rarityId = null
        this.gameExpansions = [{ name: 'Seleccione expansión', id: null, gameExpansion: [] }]
        if (this.card.gameLineId !== null) {
          var game = this.gameLines.find(x => x.id === this.card.gameLineId)
          game.gameExpansion.map(function (expansion) {
            self.gameExpansions.push(expansion)
          })
        }

        this.gameRarities = [{ name: 'Seleccione Rareza', id: null }]
        if (this.card.gameLineId !== null) {
          await this.getRarities(this.card.gameLineId)
        }
      },
    },
  }
</script>
